import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahReports } from '~constants/api';

import { PaginatedRequest, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import {
  DashboardColumnSpecsResponse,
  StatementBudgetsSummary,
  StatementBudgetsSummaryRow,
} from '~support-at-home/models/dashboard';

export type StatementBudgetsSummaryFilters = {
  date_from: string;
  date_to: string;
  client_ids?: string;
  case_manager_ids?: string;
};

interface Request extends PaginatedRequest, StatementBudgetsSummaryFilters {}

interface StatementBudgetsSummaryResponse {
  rows: StatementBudgetsSummaryRow[];
  total: number;
  summary: StatementBudgetsSummary;
}

export const statementBudgetsSummaryApi = createApi({
  reducerPath: 'statementBudgetsSummaryApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahReports }),
  tagTypes: ['statement-budgets-summary'],
  endpoints: (builder) => ({
    getStatementBudgetsSummary: builder.query<StatementBudgetsSummaryResponse, Request>({
      query: (params) => ({ url: '/statement-budget-summary', method: 'GET', params }),
      providesTags: [{ type: 'statement-budgets-summary', id: 'LIST' }],
      transformResponse: (payload) => unwrap<StatementBudgetsSummaryResponse>(payload),
    }),
    getStatementBudgetsSummarySpecs: builder.query<DashboardColumnSpecsResponse, void>({
      query: () => ({ url: '/statement-budget-summary', method: 'GET', params: { specs: true } }),
      providesTags: [{ type: 'statement-budgets-summary', id: 'SPECS' }],
      transformResponse: (payload) => unwrap<DashboardColumnSpecsResponse>(payload),
    }),
  }),
});

export const { useGetStatementBudgetsSummaryQuery, useGetStatementBudgetsSummarySpecsQuery } =
  statementBudgetsSummaryApi;
